import { MrfiktivHttpClientProvider } from "@/services/mrfiktiv/mrfiktiv-http-client.provider";
import {
  MrfiktivAppraisalResponseDtoGen,
  MrfiktivAppraisalViewModelGen,
  MrfiktivCreateRequestStatusHistoryElementDtoGen
} from "../v1/data-contracts";
import { AppraisalRequest } from "../v1/AppraisalRequest";

/**
 * Communicate with AppraisalRequest API
 */
class AppraisalRequestService {
  mrfiktivProxy: AppraisalRequest;

  /**
   * Construct service
   */
  constructor(mrfiktivHttpClientProvider: MrfiktivHttpClientProvider) {
    this.mrfiktivProxy = new AppraisalRequest(mrfiktivHttpClientProvider.client());
  }

  /**
   *
   * Gets an appraisal by shared access signature
   *
   * @param partnerId
   * @param appraisalId
   * @param token
   * @returns
   */
  async getDocumentBySharedAccessToken(
    partnerId: string,
    appraisalId: string,
    token: string
  ): Promise<MrfiktivAppraisalViewModelGen> {
    const shared = await this.mrfiktivProxy.appraisalResponseControllerGet({
      partnerId,
      appraisalId,
      sct: token
    });

    return shared.data;
  }

  /**
   *
   * Accept an appraisal request
   *
   * @param partnerId
   * @param appraisalId
   * @param token
   * @param data
   * @returns
   */
  async respondAccept(
    partnerId: string,
    appraisalId: string,
    token: string,
    data: MrfiktivAppraisalResponseDtoGen
  ): Promise<MrfiktivAppraisalViewModelGen> {
    const shared = await this.mrfiktivProxy.appraisalResponseControllerAccept(
      { partnerId, appraisalId, sct: token },
      data
    );

    return shared.data;
  }

  /**
   *
   * Reject an appraisal request
   *
   * @param partnerId
   * @param appraisalId
   * @param token
   * @returns
   */
  async respondReject(
    partnerId: string,
    appraisalId: string,
    token: string,
    data: MrfiktivCreateRequestStatusHistoryElementDtoGen
  ): Promise<MrfiktivAppraisalViewModelGen> {
    const shared = await this.mrfiktivProxy.appraisalResponseControllerReject(
      { partnerId, appraisalId, sct: token },
      data
    );

    return shared.data;
  }
}

/**
 * Communicate with AppraisalRequest API
 */
export default new AppraisalRequestService(new MrfiktivHttpClientProvider());
